import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../../constants/api';
import { useLanguage } from '../../contexts/LanguageContext';

const AdminCodesTab = ({ codes, createCode }) => {
  const { t, lang } = useLanguage();
  const dateLocale = lang === 'en' ? 'en-US' : 'es-CL';
  const [newCodeProfiles, setNewCodeProfiles] = useState(1);
  const [creating, setCreating] = useState(false);
  const [lastCreatedCode, setLastCreatedCode] = useState(null);
  const [message, setMessage] = useState('');
  const [messageIsError, setMessageIsError] = useState(false);

  const handleCreateCode = async () => {
    setCreating(true);
    setMessage('');

    const result = await createCode(newCodeProfiles);

    if (result && result.success) {
      setLastCreatedCode(result.code);
      setMessage(t('adminCodes.created', `Código creado: ${result.code}`).replace('{code}', result.code));
      setMessageIsError(false);
    } else {
      setMessage(t('adminCodes.error', 'Error al crear el código'));
      setMessageIsError(true);
    }

    setCreating(false);

    // Clear message after 5 seconds
    setTimeout(() => {
      setMessage('');
      setLastCreatedCode(null);
    }, 5000);
  };

  return (
    <div className="space-y-8">
      <div className="bg-white card-shadow-lg rounded-xl p-8">
        <h3 className="text-lg font-semibold text-black mb-6">{t('adminCodes.createNew', 'Crear Nuevo Código')}</h3>

        {message && (
          <div className={`mb-4 p-3 rounded-lg ${
            messageIsError ? 'error-state' : 'success-state'
          }`}>
            {message}
          </div>
        )}

        {lastCreatedCode && (
          <div className="mb-6 p-4 bg-sky-50 border border-sky-200 rounded-lg">
            <p className="text-sm text-sky-800 mb-2">{t('adminCodes.generatedSuccessfully', 'Código generado exitosamente:')}</p>
            <code className="bg-sky-100 text-sky-900 px-3 py-2 rounded font-mono text-lg">
              {lastCreatedCode}
            </code>
          </div>
        )}
        
        <div className="flex items-end space-x-4">
          <div>
            <label className="form-label">{t('adminCodes.numProfilesAllowed', 'Número de perfiles permitidos')}</label>
            <input
              type="number"
              min="1"
              max="1000"
              value={newCodeProfiles}
              onChange={(e) => setNewCodeProfiles(parseInt(e.target.value) || 1)}
              className="form-input w-40"
              placeholder={t('adminCodes.placeholderExample', 'Ej: 5')}
            />
          </div>
          <button
            onClick={handleCreateCode}
            disabled={creating}
            className="btn-primary"
          >
            {creating ? t('adminCodes.creating', 'Creando...') : t('adminCodes.createCode', 'Crear código')}
          </button>
        </div>
      </div>

      <div className="bg-white card-shadow-lg rounded-xl p-8">
        <h3 className="text-lg font-semibold text-black mb-6">{t('adminCodes.activationCodes', 'Códigos de Activación')}</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('adminCodes.code', 'Código')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('adminCodes.status', 'Estado')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('adminCodes.profiles', 'Perfiles')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('adminCodes.createdCol', 'Creado')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('adminCodes.usedCol', 'Usado')}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {codes.map((code) => (
                <tr key={code.id}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <code className="bg-gray-100 px-2 py-1 rounded font-mono text-sm">
                      {code.code}
                    </code>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      code.used 
                        ? 'bg-red-100 text-red-800' 
                        : 'bg-green-100 text-green-800'
                    }`}>
                      {code.used ? t('adminCodes.used', 'Usado') : t('adminCodes.available', 'Disponible')}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {code.max_profiles}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {new Date(code.created_at).toLocaleDateString(dateLocale)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {code.used_at ? new Date(code.used_at).toLocaleDateString(dateLocale) : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default AdminCodesTab;
